import { CSSProperties } from "react";
import { Path, Control, useController, FieldValues, FieldError } from "react-hook-form";
import { Switch, FormControlLabel, FormHelperText, FormGroup } from "@mui/material";

interface FormInputSwitchProps<K extends FieldValues> {
    label: string;
    name: Path<K>;
    control: Control<K>;
    error?: FieldError;
    disabled?: boolean;
    readonly?: boolean;
    style?: CSSProperties;
    styleLabel?: CSSProperties;
}

export default function InputSwitch<T extends FieldValues>(props: FormInputSwitchProps<T>) {
    const { field: switchField } = useController({
        name: props.name,
        control: props.control,
    });

    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <Switch
                        {...switchField}
                        checked={!!switchField.value}
                        onChange={(event) => switchField.onChange(event.target.checked)}
                        disabled={props.disabled}
                        inputProps={{ readOnly: props.readonly }}
                        sx={props.style}
                    />
                }
                label={props.label}
                sx={props.styleLabel}
            />
            {props.error && <FormHelperText error>{props.error.message}</FormHelperText>}
        </FormGroup>
    );
}
